import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});


// Interceptor de requisição para adicionar token dinamicamente
api.interceptors.request.use(
  (config) => {
    
    const user_obj = localStorage.getItem('user');
    
    if (user_obj) {
      try {
        const user = JSON.parse(user_obj);
        const token = user.token;

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (e) {
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepta respostas para lidar com status === 3
api.interceptors.response.use(
  async (response) => {
    const responseData = response?.data;

    // Ignora endpoints de signup/login
    const ignoredEndpoints = ['/user', '/auth', '/prescription/show_by_code']; // ajustar conforme necessário
    if (ignoredEndpoints.includes(response.config.url)) {
      return response; // não faz logout
    }

    // Se a API responder com status 3 (token expirado), faz refresh
    if (responseData?.status === 3 && !response.config._retry) {
      console.log('Token expirado, tentando refresh...');

      response.config._retry = true;

      const user_obj = localStorage.getItem('user');
      if (!user_obj) {
        logoutAndRedirect();
        return;
      }

      const user = JSON.parse(user_obj);
      const refreshToken = user.refresh_token;

      if (!refreshToken) {
        logoutAndRedirect();
        return;
      }

      try {
        const refreshResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}refresh_token`,
          { token: refreshToken }
        );

        const refreshData = refreshResponse?.data;

        // Verificações de segurança para evitar erro de leitura
        const expiredTokenMsg =
          refreshData?.data === 'Expired token' ||
          refreshData?.data?.data === 'Expired token';

        if (
          !refreshData ||
          !refreshData.data ||
          refreshData.status === 0 ||
          expiredTokenMsg ||
          refreshData.message?.toLowerCase().includes('renovar token')
        ) {
          throw new Error('Refresh token inválido ou expirado');
        }

        const {
          token: newToken,
          refresh_token: newRefresh,
          user: refreshedUserData
        } = refreshData.data;

        localStorage.setItem('user', JSON.stringify(refreshData.data));

        response.config.headers.Authorization = `Bearer ${newToken}`;
        return api(response.config);

      } catch (refreshError) {
        console.warn('Erro ao tentar refresh:', refreshError);
        logoutAndRedirect();
        return;
      }
    }

    // Se status 0 + mensagem de token expirado no corpo da resposta
    if (responseData?.status === 0) {
      console.log('Token inválido ou expirado');
      alert(responseData?.message);
      window.location.href = '/login';
      //logoutAndRedirect();
      return;
    }

    return response;
  },
  (error) => {
    console.error('Erro HTTP real:', error);
    return Promise.reject(error);
  }
);

// Centraliza logout com proteção visual
function logoutAndRedirect() {
  localStorage.removeItem('user');
  window.location.href = '/login';
  return;
}

export default api;